import { RGLogo } from "components/UI/RGLogo";
import AdTab from "components/ads/AdTab";
import { tabs } from "components/ads/config/tabs";
import { BurgerButton } from "components/buttons/BurgerButton/BurgerButton";
import { Fragment, useCallback } from "react";
import { useDeviceType } from "@/common/hooks/useDeviceType";
import { deviceTypeEnum } from "@/common/utils/device";
import { useAppStore } from "@/common/store/appStore";
import { GlobalSearch } from "@/components/search/GlobalSearch";
import { BurgerMenu } from "@/components/burger-menu/BurgerMenu";
import { metricsBus } from "@/common/buses";

import "./MainHeader.scss";

export const MainHeader = () => {
  const isSearchBarOpen = useAppStore((state) => state.isSearchBarOpen);
  const deviceType = useDeviceType();
  const isDesktop = deviceType === deviceTypeEnum.DESKTOP;
  const toggleBurgerMenu = useAppStore((state) => state.toggleBurgerMenu);

  const handleBurgerMenuButton = useCallback(() => {
    toggleBurgerMenu();
  }, [toggleBurgerMenu]);

  const handleRedgifsAiClick = useCallback(() => {
    metricsBus.emit("redgifsAiClicked", { spot: "desktop tab" });
  }, []);

  return (
    <Fragment>
      {(isDesktop || !isSearchBarOpen) && <RGLogo isFull={isDesktop} />}
      <div className="topNav-wrap">
        <div>
          { isDesktop && <AdTab link={tabs.LiveSex.link}>Watch Live Sex</AdTab> }
        </div>
        <GlobalSearch />
        <div>
          { isDesktop && <AdTab link={tabs.RedGIFsAI.link} onClick={handleRedgifsAiClick}>AI Porn</AdTab> }
        </div>
        {(isDesktop || !isSearchBarOpen) && <BurgerButton onClick={handleBurgerMenuButton}/>}
      </div>
      <BurgerMenu />
    </Fragment>
  );
};
